





































import {Component, Vue, Watch} from "vue-property-decorator";

import {apiService} from '../services/api-service';
import {cartService} from '../services/cart-service';
import {Image, Item} from "../model";
import KkImage from '@/components/KK-Image.vue';
import MainButton from '@/components/MainButton.vue';

@Component({
  components: {KkImage, MainButton}
})
export default class ItemView extends Vue {
  item: Item|null = null;
  currentImage: Image|null = null;

  created() {
    this.load(parseInt(this.$route.params.id));
  }

  @Watch('$route') routeChanged(newRoute: any) {
    this.load(parseInt(newRoute.params.id));
  }

  async load(id: number) {
    this.item = await apiService.loadItem(id);
    this.currentImage = this.item.getFirstImage();
  }

  selectImage(img: Image) {
    this.currentImage = img;
  }

  addToCart() {
    if (this.item) {
      cartService.addToCart(this.item);
    }
  }
}
